module.exports = __webpack_public_path__ + "static/img/103896.dc87b482.png";